import './header.scss'

import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useRecoilState, useRecoilValue } from 'recoil'
import { Paths } from 'src/navigation'
import { usePutDossier } from 'src/networking/terminals'
import { atomDossier, selectorDossierInsured } from 'src/storage'
import { Dossier } from 'src/types'
import { mapDossier, useBoolean } from 'src/utils'

export const useHeader = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const insured = useRecoilValue(selectorDossierInsured)
  const [dossier, setDossier] = useRecoilState(atomDossier)
  const { crossGate: putDossier } = usePutDossier('clearDossier')

  const [showMenu, , closeMenu, toggleMenu] = useBoolean(false)
  const dropdownRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        closeMenu()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  function resetDossier(): void {
    putDossier(
      {
        headers: {
          xDossierId: dossier?.dossierId,
        },
        body: {
          productCode: null,
        },
      },
      {
        onSuccess: (newDossier) => {
          const dossier: Dossier = mapDossier(newDossier)
          setDossier(dossier)
          navigate(Paths.Landing)
        },
      }
    )
  }

  function onClaimsLabelClick() {
    window.open('https://www.gruppoitas.it/sinistri-FIAIP', '_blank')
  }

  return {
    insured,
    t,
    showMenu,
    dropdownRef,
    toggleMenu,
    resetDossier,
    onClaimsLabelClick,
  }
}
